<template>
    <div v-if="anfrage != undefined" :class="className">
        <anfragen-anzeige-info v-model="anfrage"/>
        <anfragen-anzeige-nachrichten v-model="anfrage"/>
    </div>
</template>

<script>
import { mapGetters } from "vuex"
import AnfragenAnzeigeNachrichten from "../components/AnfragenAnzeigeNachrichten.vue"
import AnfragenAnzeigeInfo from "../components/AnfragenAnzeigeInfo.vue"
export default {
    name: "AnfragenAnzeige",
    components:{
        AnfragenAnzeigeNachrichten,
        AnfragenAnzeigeInfo,
    },
    watch:{
        $route:function(){
            if(this.className == this.baseClass + ' switch')
                return
            this.className = this.baseClass + ' switch'
            setTimeout(() => this.className = this.baseClass, 600)
        }
    },
    data(){
        return{
            baseClass: 'd-flex flex-column justify-content-center',
            className: 'd-flex flex-column justify-content-center'
        }
    },
    computed: {
        ...mapGetters(['anfragen']),
        anfrage: function() {
            return this.anfragen.find(x => x.id == this.$route.query.aid)
        }
    }
}
</script>

<style>
    .switch {
        -webkit-animation: switch .4s ease-in-out;
        -moz-animation: switch .4s ease-in-out;
        -ms-animation: switch .4s ease-in-out;
        -o-animation: switch .4s ease-in-out;
        animation: switch .4s ease-in-out;
        transform-origin: left;
    }

    @keyframes switch {
        0%, 100% { transform: skew(0, 0) }
        33%   { transform: skew(0, 1deg) }
        66%   { transform: skew(0, -1deg) }
    }

    /* Firefox < 16 */
    @-moz-keyframes switch {
        0%, 100% { transform: skew(0, 0) }
        33%   { transform: skew(0, 1deg) }
        66%   { transform: skew(0, -1deg) }
    }

    /* Safari, Chrome and Opera > 12.1 */
    @-webkit-keyframes switch {
        0%, 100% { transform: skew(0, 0) }
        33%   { transform: skew(0, 1deg) }
        66%   { transform: skew(0, -1deg) }
    }

    /* Internet Explorer */
    @-ms-keyframes switch {
        0%, 100% { transform: skew(0, 0) }
        33%   { transform: skew(0, 1deg) }
        66%   { transform: skew(0, -1deg) }
    }

    /* Opera < 12.1 */
    @-o-keyframes switch {
        0%, 100% { transform: skew(0, 0) }
        33%   { transform: skew(0, 1deg) }
        66%   { transform: skew(0, -1deg) }
    }
</style>